import React from "react";
import TextField from "@material-ui/core/TextField";
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import formStyle from "../../styles/forms"
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Checkbox from '@material-ui/core/Checkbox';
import WorkHours from "../users/workhours"
import Holiday from "../users/holiday";
import Docter from "../users/docter";
import Baby from "../users/baby";
class UserEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = { selectedTab: 0 }
  }
  update = (ev) => {
    let item = Object.assign({}, this.props.item);
    item[ev.target.id] = ev.target.value;
    this.props.handleUpdate(item);
  }
  updateType = (ev) => {
    let item = Object.assign({}, this.props.item);
    item.type = ev.target.value;
    this.props.handleUpdate(item);
  }
  updateHolidayHours = (newHolidayHours) => {
    let item = Object.assign({}, this.props.item);
    item.holydayhours = newHolidayHours;
    this.props.handleUpdate(item);
  }
  updateDocterHours = (newDocterHours) => {
    let item = Object.assign({}, this.props.item);
    item.docterhours = newDocterHours;
    this.props.handleUpdate(item);
  }
  updateBabyHours = (newBabyHours) => {
    let item = Object.assign({}, this.props.item);
    item.babyhours = newBabyHours;
    this.props.handleUpdate(item);
  }
  updateAdminModule = (adminmodule) => {
    let item = Object.assign({}, this.props.item);
    if (item.adminmodules === undefined) { item.adminmodules = [] }
    if (item.adminmodules.find(mod => { return mod === adminmodule }) === undefined) {
      item.adminmodules.push(adminmodule);
    } else {
      item.adminmodules = item.adminmodules.filter(mod => { return mod !== adminmodule })
    }
    this.props.handleUpdate(item);
  }
  hasAdminModule = (adminmodule) => {
    if (this.props.item.adminmodules) {
      return this.props.item.adminmodules.find(mod => { return mod === adminmodule }) !== undefined;
    } else {
      return false;
    }
  }
  handleChangeStatusTab = (event, value) => {
    this.setState({ selectedTab: value })
  }

  render() {
    return (
      <React.Fragment>
        <AppBar position="static" color="secondary">
          <Tabs value={this.state.selectedTab} onChange={this.handleChangeStatusTab}>
            <Tab label="Algemeen" />
            <Tab label="Toegang" />
            <Tab label="Uren" />
            <Tab label="Vakantieuren" />
            <Tab label="Dokter" />
            <Tab label="Ouderschapsverlof" />
          </Tabs>
        </AppBar>
        {
          this.state.selectedTab === 0
          &&
          <div className="padding">
            <FormControl>
              <InputLabel htmlFor="type">Type</InputLabel>
              <Select
                style={formStyle.selectField}
                value={this.props.item.type || 0}
                onChange={this.updateType}
                inputProps={{
                  name: 'type',
                  id: 'type',
                }}
              >
                <MenuItem value={0}>Onbekend</MenuItem>
                <MenuItem value={3}>ZZP-er</MenuItem>
                <MenuItem value={2}>Uitzendkracht</MenuItem>
                <MenuItem value={1}>Personeel</MenuItem>
              </Select>
            </FormControl>
            <TextField
              autoFocus
              margin="dense"
              id="lastname"
              label="Achternaam"
              type="text"
              value={this.props.item.lastname || ""}
              onChange={this.update}
              fullWidth
              required
            />
            <TextField
              margin="dense"
              id="firstname"
              label="Voornaam"
              type="text"
              value={this.props.item.firstname || ""}
              onChange={this.update}
              fullWidth
              required
            />
            <TextField
              margin="dense"
              id="email"
              label="Email"
              type="text"
              value={this.props.item.email || ""}
              onChange={this.update}
              fullWidth
              required
            />
            <TextField
              margin="dense"
              id="phone"
              label="Telefoonnummer"
              type="text"
              value={this.props.item.phone || ""}
              onChange={this.update}
              fullWidth
            />
            <TextField
              margin="dense"
              id="mobile"
              label="Mobiel nummer"
              type="text"
              value={this.props.item.mobile || ""}
              onChange={this.update}
              fullWidth
            />
            <TextField
              margin="dense"
              id="function"
              label="Functie"
              type="text"
              value={this.props.item.function || ""}
              onChange={this.update}
              fullWidth
            />
          </div>
        }
        {
          this.state.selectedTab === 1
          &&
          <div className="padding">


            <br />
            <FormControl>
              <InputLabel htmlFor="amdin" shrink={true}>Beheermodules</InputLabel>
              <div id="admin" name="admin">
                <br />
                <Checkbox onChange={() => this.updateAdminModule('clients')} checked={this.hasAdminModule('clients')} />Klanten<br />
                <Checkbox onChange={() => this.updateAdminModule('projects')} checked={this.hasAdminModule('projects')} />Projecten<br />
                <Checkbox onChange={() => this.updateAdminModule('users')} checked={this.hasAdminModule('users')} />Gebruikers<br />
                <Checkbox onChange={() => this.updateAdminModule('workorders')} checked={this.hasAdminModule('workorders')} />Werkbonnen<br />
                <Checkbox onChange={() => this.updateAdminModule('accounting')} checked={this.hasAdminModule('accounting')} />Boekhouding<br />
                <Checkbox onChange={() => this.updateAdminModule('messages')} checked={this.hasAdminModule('messages')} />Berichten<br />
                <Checkbox onChange={() => this.updateAdminModule('calendar')} checked={this.hasAdminModule('calendar')} />Kalender<br />
                <Checkbox onChange={() => this.updateAdminModule('settingsapp')} checked={this.hasAdminModule('settingsapp')} />Instellingen App<br />
              </div>
            </FormControl>
            <br />
            <TextField
              margin="dense"
              id="newpassword"
              label="Instellen nieuw wachtwoord"
              type="password"
              value={this.props.item.newpassword || ""}
              onChange={this.update}
              fullWidth
            />
          </div>
        }
        {
          this.state.selectedTab === 2
          &&
          <div>
            <WorkHours user={this.props.item}   ></WorkHours>
          </div>
        }
        {
          this.state.selectedTab === 3
          &&
          <div>
            <Holiday user={this.props.item} onChange={this.updateHolidayHours} holidays={this.props.holidays}></Holiday>
          </div>
        }
        {
          this.state.selectedTab === 4
          &&
          <div>
            <Docter user={this.props.item} onChange={this.updateDocterHours} docters={this.props.docters}></Docter>
          </div>
        }
        {
          this.state.selectedTab === 5
          &&
          <div>
            <Baby user={this.props.item} onChange={this.updateBabyHours} babies={this.props.babies}></Baby>
          </div>
        }
      </React.Fragment>

    );
  }
}
export default UserEdit;
